import axios from "axios";

export default class reportPhotos {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getReportedUsers() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/chat/cms`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteUserPhoto(data) {
    try {
      const response = await axios({
        method: "delete",
        url: `${this.API_LINK}/chat/report`,
        data: data
      });
      return response.data;
    } catch (error) {}
  }
}
